@if (!this.showContent()) {
  <div class="flex min-h-screen w-full items-center justify-center">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
} @else {
  <div class="slick-login-container mx-auto flex min-h-screen w-full flex-row">
    <div class="w-full bg-white p-4 lg:w-[55%] lg:px-28 xl:w-[46.6%] xl:px-28 xl:py-24">
      <div class="flex flex-col gap-3">
        <div class="pb-3">
          <img
            class="my-8 w-20 sm:my-8 lg:mb-8 lg:mt-12 xl:mt-0"
            src="../../assets/img/slick_plus_logo_colorful.svg"
            alt="Slick+ logo"
          />
          <div class="text-black text-xl font-semibold leading-10">Welcome back</div>
          <div class="text-xs text-[#79747E] lg:text-base">One step away from your knowledge diffusion</div>
        </div>
        <form class="flex w-full flex-col gap-3" (ngSubmit)="this.login(loginForm.value)" [formGroup]="loginForm">
          <mat-form-field
            (keydown)="this.clearErrors($event)"
            appearance="outline"
            floatLabel="always"
            class="relative w-full"
          >
            <mat-label>Email</mat-label>
            <input
              class="text-base sm:text-sm"
              formControlName="email"
              matInput
              type="email"
              placeholder="Enter your email"
              autocomplete="email"
            />
            @if (!this.loginForm.get('email').valid && this.loginForm.get('email').touched) {
              <mat-icon matSuffix class="text-[--mat-form-field-error-text-color]">error</mat-icon>
            }
            <mat-error MatError class="absolute bottom-[-20px] left-[12px] w-full">
              @for (error of errors(loginForm.get('email')); track error) {
                {{ errorMessages[error] }} <br />
              }
            </mat-error>
          </mat-form-field>

          <mat-form-field
            (keydown)="this.clearErrors($event)"
            appearance="outline"
            floatLabel="always"
            class="relative w-full"
          >
            <mat-label>Password</mat-label>
            <input
              class="text-base sm:text-sm"
              formControlName="password"
              autocomplete="current-password"
              matInput
              [type]="passwordVisible ? 'text' : 'password'"
              placeholder="Enter your password"
            />
            <mat-error MatError class="absolute bottom-[-20px] left-[12px] w-full">
              @for (error of errors(loginForm.get('password')); track error) {
                {{ errorMessages[error] }} <br />
              }
            </mat-error>
            <button
              class="mx-3"
              type="button"
              mat-icon-button
              matSuffix
              matRipple
              (click)="passwordVisible = !passwordVisible"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="!passwordVisible"
            >
              <mat-icon>{{ passwordVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
          </mat-form-field>
          <div class="relative left-[10px] top-[-15px] flex flex-row">
            <span
              [routerLink]="'/forgot-password'"
              class="align-right my-auto cursor-pointer text-right text-sm font-normal text-purple-200 hover:underline"
              >Forgot password?</span
            >
          </div>
          @if (rateLimitMessage()) {
            <div
              class="flex items-start gap-2 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
            >
              <mat-icon class="mt-0.5 shrink-0 text-base leading-none">lock_clock</mat-icon>
              <span>{{ rateLimitMessage() }}</span>
            </div>
          }
          <div>
            <button
              class="w-full rounded-lg bg-purple-200 p-3 text-sm font-semibold text-white disabled:opacity-50"
              type="submit"
              [disabled]="!!rateLimitMessage()"
            >
              @if (!isLoading()) {
                <span>Log in</span>
              } @else {
                <mat-spinner class="m-auto" diameter="24"></mat-spinner>
              }
            </button>
          </div>
        </form>
      </div>
      <div class="separator my-6 text-center text-base font-normal text-[#79747E]">or continue with</div>
      <div class="">
        <button
          class="flex w-full flex-row items-center gap-3 rounded-lg border px-3 py-2 text-center disabled:opacity-50"
          type="button"
          [disabled]="isMicrosoftLoading()"
          (click)="continueWithMicrosoft()"
        >
          <img class="" src="../../assets/img/login/microsoft-entra-id-color_icon.svg" alt="" />
          <span class="text-[#79747E]">Continue with Microsoft</span>
        </button>
      </div>
      <div class="mt-6 text-center text-sm text-[#79747E]">
        <p class="mb-3">
          <span class="font-medium">New to Slick+?</span> Slick+ is available to organisations.
          <br />
          To get access, ask your administrator or contact us to get started.
        </p>
        <div>
          <a
            href="https://slick.plus/"
            target="_blank"
            rel="noopener noreferrer"
            class="cursor-pointer font-medium text-purple-200 hover:underline"
            >Learn more</a
          >
          <span class="mx-1.5 text-[#79747E]/40">|</span>
          <a
            href="https://slick.plus/book-demo/"
            target="_blank"
            rel="noopener noreferrer"
            class="cursor-pointer font-medium text-purple-200 hover:underline"
            >Book a demo</a
          >
          <span class="mx-1.5 text-[#79747E]/40">|</span>
          <a
            href="https://slick.plus/contact-us/"
            target="_blank"
            rel="noopener noreferrer"
            class="cursor-pointer font-medium text-purple-200 hover:underline"
            >Contact Us</a
          >
        </div>
      </div>
    </div>
    <div class="hidden w-[60%] lg:block">
      <app-screen-banner></app-screen-banner>
    </div>
  </div>
}
